/**
 * useToast — module-level event bus for fire-and-forget toast notifications.
 * No React context needed. Any component can call showToast() directly.
 *
 * Usage:
 *   import { showToast } from '../hooks/useToast';
 *   showToast('Slot booked!');
 *   showToast('Something failed', 'error');
 */

const bus = new EventTarget();

export function showToast(message, type = 'success') {
  bus.dispatchEvent(
    Object.assign(new Event('toast'), { detail: { message, type, id: Date.now() } })
  );
}

export function onToast(handler) {
  bus.addEventListener('toast', handler);
  return () => bus.removeEventListener('toast', handler);
}
